import React from "react";

const TextAnswer = ({ text, selectedAns, type }) => {
  const productArray = localStorage.getItem("products")
    ? JSON.parse(localStorage.getItem("products"))
    : [];

  // ✅ Create formatted display string for inventory type
  const formattedText =
    selectedAns?.length > 0 &&
    selectedAns
      ?.map((ans) => {
        const matchedProduct = productArray.find((p) => p._id === ans?.id);
        return matchedProduct
          ? `${matchedProduct.serial_no}: ${ans?.value}`
          : null;
      })
      .filter(Boolean) // Remove nulls if not matched
      .join(", ");
  return (
    <div className="text-black bg-white rounded-br-none shadow rounded-2xl">
      <div className="px-3 py-2 answerArea text-left">
        {type === "inventory" ? formattedText : text || ""}
      </div>
    </div>
  );
};
export default TextAnswer;
